import { TranscriptionMeetingResponseModel } from '../../models/transcriptionModel/transcription-meeting-response-model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { TranscriptionResponseModel } from '../../models/transcriptionModel/TranscriptionResponseModel';
import { TranscriptionDefaultResponse } from '../../models/transcriptionModel/TranscriptionDefaulResponse';
import { TranscriptionVersionsResponse } from '../../models/previousEditionsModel/GetTranscriptionMeetingResponse';
import { ResponseType } from '@angular/http';

@Injectable({
    providedIn: 'root'
})

export class TranscriptionService {
    private base = environment.urlServerApi+'transcriptions';

    constructor(private _http: HttpClient){
    }

    getTranscriptionByFilter(data:any){
        return this._http.post<TranscriptionResponseModel>(`${this.base}`, data)
    }

    getTranscriptionVersion(sentenceId:number){
        return this._http.get<TranscriptionVersionsResponse>(`${this.base}/versions?sentenceId=${sentenceId}`)
    }

    getTranscriptionMeeting(meetingId:number, published:boolean) : Observable<TranscriptionMeetingResponseModel> {
        return this._http.get<TranscriptionMeetingResponseModel>(`${this.base}/meetings?meetingId=${meetingId}&published=${published}`, 
        { headers: new HttpHeaders({'Access-Control-Allow-Origin':'*'})});
    }

    getTranscriptionsMeetingByfilter(filters:any): Observable<TranscriptionMeetingResponseModel> {
        return this._http.post<TranscriptionMeetingResponseModel>(`${this.base}/filters`, filters, 
        { headers: new HttpHeaders({'Access-Control-Allow-Origin':'*'})})
    }
    
    getPdf(meetingId:number, languageId:number): Observable<any> {
        const requestOptions: Object = {
            responseType: 'blob'
        }
        const url = `${this.base}/pdf?meetingId=${meetingId}&languageId=${languageId}`;
        return this._http.get<any>(url, requestOptions);
    }

    getWord(meetingId:number, languageId:number): Observable<any> {
        const requestOptions: Object = {
            responseType: 'blob'
        }
        const url = `${this.base}/word?meetingId=${meetingId}&languageId=${languageId}`;
        return this._http.get<any>(url,requestOptions);
    }

    getTranscriptionsMeetingVersion(meetingId:number, version:number) : Observable<TranscriptionMeetingResponseModel> {
        return this._http.get<TranscriptionMeetingResponseModel>(`${this.base}/meetings/versions?meetingId=${meetingId}&version=${version}`)
    }

    saveTranscriptionEdition(data:any): Observable<TranscriptionDefaultResponse>
    {
        return this._http.post<TranscriptionDefaultResponse>(`${this.base}/edit`, data)
    }
}